import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import "./index.scss";

const FAQ = ({
  fetchData, // Function to fetch FAQ data
  title, // Title for the FAQ section
  subtitle,
}) => {
  const [openKey, setOpenKey] = useState("0");
  const [faqData, setFaqData] = useState([]);

  useEffect(() => {
    const fetchFAQs = async () => {
      const data = await fetchData();
      setFaqData(data?.faqs?.data);
    };
    fetchFAQs();
  }, [fetchData]);

  const handleToggle = (key) => {
    setOpenKey((prevKey) => (prevKey === key ? null : key));
  };

  return (
    <div className="faq-main-container">
      <div className="faq-details">
        <h2 className="faq-title">{title}</h2>
        <div className="faq-desc">{subtitle}</div>
      </div>
      <div className="faq-list">
        <Accordion defaultActiveKey="0" className="faq-accordion-container">
          {faqData?.map((item) => (
            <Accordion.Item eventKey={item?.id} key={item?.id}>
              <Accordion.Header onClick={() => handleToggle(item?.id)}>
                {item?.attributes?.question}
              </Accordion.Header>
              <Accordion.Body>{item?.attributes?.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default FAQ;
